import classNames from 'classnames';
import { default as React } from 'react';
import { MedicationExpiry, MedicationStatus } from '../Contracts/MedicationModels';
import { expiryStatusFromDate } from '../Shared/MedicationsHelpers';
import { MedicationsSummaryListActions } from './MedicationsSummaryListActions';
import styles from './MedicationSummaryListItem.module.css';
export var MedicationSummaryListItem = function (props) {
    var _a;
    var _b, _c, _d, _e;
    var selected = false;
    var expired = false;
    var aboutToExpire = false;
    if (props.selectedId) {
        var expiresOn = null;
        var status_1 = null;
        if (props.selectedId === props.medicationsSummaryResponse.lastMedication.id) {
            selected = true;
            expiresOn = props.medicationsSummaryResponse.lastMedication.expiresOn;
            status_1 = props.medicationsSummaryResponse.lastMedication.status;
        }
        var expiryStatus = expiryStatusFromDate(expiresOn);
        var stopped = status_1 === MedicationStatus.Stopped;
        expired = !stopped && expiryStatus === MedicationExpiry.Expired;
        aboutToExpire = !stopped && expiryStatus === MedicationExpiry.AboutToExpire;
    }
    var cardClasses = classNames(styles.cardContainer, (_a = {},
        _a[styles.selected] = selected,
        _a[styles.expired] = expired,
        _a[styles.aboutToExpire] = aboutToExpire,
        _a));
    var medCode = (_c = (_b = props.medicationsSummaryResponse.productPack) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : '';
    var medName = ((_e = (_d = props.medicationsSummaryResponse.productPack) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : '').substr(0, 20);
    return (React.createElement("div", { className: cardClasses, "data-test-med-code": medCode, "data-test-med-name": medName },
        React.createElement(MedicationsSummaryListActions, { serviceAuthoringSystem: props.serviceAuthoringSystem, serviceAuthoringSystemForeignKey: props.serviceAuthoringSystemForeignKey, encounterAuthoringSystem: props.encounterAuthoringSystem, encounterAuthoringSystemForeignKey: props.encounterAuthoringSystemForeignKey, patient: props.patient, filterState: props.filterState, item: props.medicationsSummaryResponse, selectedId: props.selectedId, onClick: props.onClick, stopMedication: props.stopMedication, onDelete: props.onMedicationDeleted, deleteMedication: props.deleteMedication, saveMedicationsToReprescribe: props.saveMedicationsToReprescribe, saveFreeTextMedicationToReprescribe: props.saveFreeTextMedicationToReprescribe, canReprescribe: props.canReprescribe, onReprescribe: props.onReprescribe, medicationTimeLineState: props.medicationTimeLineState, controlledMedicationHandler: props.controlledMedicationHandler })));
};
